import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { authenticated, login } = useAuth();
  const authId = sessionStorage.getItem('id') || localStorage.getItem('id');
  return (
    <Route
      {...rest}
      render={(props) =>
        authId > 0 ? (
          <Component {...props} />
        ) : ( <Redirect to="/" />
        )
      }
    />
  );
};

export default PrivateRoute;